import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { DepositWithdrawComponent } from '../deposit-withdraw.component';

@UntilDestroy()
@Component({
  standalone: true,
  selector: 'deposit-withdraw-forbid',
  templateUrl: './deposit-withdraw-forbid.component.html',
  styleUrls: ['./deposit-withdraw-forbid.component.scss'],
  imports: [CSButtonComponent, CommonModule, LoadingModule],
})
export class DepositWithdrawForbidComponent implements OnInit {
  constructor(
    private appService: AppService,
    private dialogRef: MatDialogRef<DepositWithdrawComponent>,
  ) {}

  @Input() isLoading: boolean = false;

  ngOnInit() {}

  contactSupport() {
    this.dialogRef.close();
    this.appService.toOnLineService$.next(true);
  }
}
